import { StateCreator } from 'zustand';

import { RemoveFunctions } from '../../utils/types';

type SigningRequestState = 'initializing' | 'signing' | 'finalizing';

export type SigningRequest = {
  documentId: string;
  state: SigningRequestState;
};

export type DocumentSigningSlice = {
  currentSigningRequests: SigningRequest[];
  addSigningRequest(documentId: string): void;
  updateSigningRequest(documentId: string, newState: SigningRequestState): void;
  removeSigningRequest(documentId: string): void;
  /** Removes a signing request if it is not in the "finalizing" state */
  removeSigningRequestInProgress(documentId: string): void;
  isSigningInProgress(): boolean;
  resetDocumentSigningSlice: () => void;
};

const initialState: RemoveFunctions<DocumentSigningSlice> = {
  currentSigningRequests: [],
};

export const createDocumentSigningSlice: StateCreator<
  DocumentSigningSlice,
  [],
  [],
  DocumentSigningSlice
> = (setState, getState) => {
  return {
    ...initialState,
    addSigningRequest(documentId: string) {
      setState((state) => ({
        ...state,
        currentSigningRequests: [
          ...state.currentSigningRequests,
          { documentId, state: 'initializing' },
        ],
      }));
    },
    updateSigningRequest(documentId: string, newState: SigningRequestState) {
      setState((state) => ({
        ...state,
        currentSigningRequests: state.currentSigningRequests.map((r) =>
          r.documentId === documentId ? { documentId, state: newState } : r
        ),
      }));
    },
    removeSigningRequest(documentId: string) {
      setState((state) => ({
        ...state,
        currentSigningRequests: state.currentSigningRequests.filter(
          (r) => r.documentId !== documentId
        ),
      }));
    },
    removeSigningRequestInProgress(documentId: string) {
      setState((state) => ({
        ...state,
        currentSigningRequests: state.currentSigningRequests.filter(
          (r) => r.documentId !== documentId || r.state === 'finalizing'
        ),
      }));
    },
    isSigningInProgress(): boolean {
      return getState().currentSigningRequests.some(
        (r) => r.state !== 'finalizing'
      );
    },
    resetDocumentSigningSlice() {
      setState({
        ...initialState,
      });
    },
  };
};
